import { apiClient } from '../client';
import { Role, RolePermission, PermissionScope } from '../../types/admin';

export const rolesApi = {
  list: () => apiClient.get<{ data: Role[] }>('/api/admin/roles'),
  create: (input: { name: string; description?: string | null }) =>
    apiClient.post<{ data: { id: number } }>('/api/admin/roles', input),
  update: (id: number, input: { name: string; description?: string | null }) =>
    apiClient.put<{ data: { id: number } }>(`/api/admin/roles/${id}`, input),
  deactivate: (id: number) => apiClient.patch<{ data: { id: number; is_active: boolean } }>(`/api/admin/roles/${id}/deactivate`),

  permissions: (roleId: number) => apiClient.get<{ data: RolePermission[] }>(`/api/admin/roles/${roleId}/permissions`),
  grantPermission: (roleId: number, input: { permissionKey: string; scope: PermissionScope }) =>
    apiClient.post<{ data: unknown }>(`/api/admin/roles/${roleId}/permissions`, input),
  revokePermission: (roleId: number, permissionKey: string) =>
    apiClient.delete<{ data: unknown }>(`/api/admin/roles/${roleId}/permissions/${encodeURIComponent(permissionKey)}`),
};

export const userRolesApi = {
  list: (userId: number) => apiClient.get<{ data: Role[] }>(`/api/admin/users/${userId}/roles`),
  assign: (userId: number, roleId: number) => apiClient.post<{ data: unknown }>(`/api/admin/users/${userId}/roles`, { roleId }),
  remove: (userId: number, roleId: number) => apiClient.delete<{ data: unknown }>(`/api/admin/users/${userId}/roles/${roleId}`),
};

export interface ApprovalMatrixHealthIssue {
  module: string; approverRole: string; conditionType: string; conditionValue: string; missingPermissions: string[]; usersHoldingRole: number;
}

export const approvalMatrixHealthApi = {
  check: () => apiClient.get<{ data: { issues: ApprovalMatrixHealthIssue[]; healthy: ApprovalMatrixHealthIssue[]; checkedAt: string } }>('/api/admin/approval-matrix-health'),
};

export interface PermissionOverride {
  id: number;
  user_id: number;
  permission_key: string;
  scope: PermissionScope;
  is_granted: number;
}

export const permissionOverridesApi = {
  list: (userId: number) => apiClient.get<{ data: PermissionOverride[] }>(`/api/admin/users/${userId}/permission-overrides`),
  set: (userId: number, input: { permissionKey: string; scope: PermissionScope; isGranted: boolean }) =>
    apiClient.post<{ data: unknown }>(`/api/admin/users/${userId}/permission-overrides`, input),
  remove: (userId: number, permissionKey: string) =>
    apiClient.delete<{ data: unknown }>(`/api/admin/users/${userId}/permission-overrides/${encodeURIComponent(permissionKey)}`),
};
